import styled from "styled-components";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.components.errorFlag;

// STYLES
export const LogoWrapper = styled.div`
  width: 100%;
  max-width: 40rem;
`;

export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
  width: 45rem;
  text-align: center;
`;

export const Spacer = styled.div<{ $height: string }>`
  height: ${({ $height }) => $height};
  min-height: ${({ $height }) => $height};
  flex-shrink: 0;
`;

// DATA

// TYPES
export type Props = {
  header?: string;
  message?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
